import { useQuery } from '../models/reactUtils'
import { observer } from 'mobx-react'
import React from 'react'

import DolphinBooking from '@intelibly/dolphin-booking'
import InteliblyRequest from '@intelibly/intelibly-request'
import ManualBooking from '@intelibly/manual-booking'
import ScheduleConnectBooking from '@intelibly/scheduleconnect-booking'

import * as Analytics from '../utils/analytics'

const BookingPath = observer(() => {
  const { store } = useQuery()
  const selectedLocation = store.selectedLocation
  if (selectedLocation) {
    switch (selectedLocation.bookingExperience) {
      case 'dolphin':
        store.debug('RENDERING DOLPHIN BOOKING')
        Analytics.dolphinBookingOpened(
          store.selectedLocation.id,
          store.partnerId
        )
        return (
          <DolphinBooking
            locationId={store.locationId}
            partnerId={store.partnerId}
          />
        )
      case 'intelibly_direct':
        store.debug('RENDERING INTELIBLY REQUEST')
        Analytics.inteliblyRequestOpened(
          store.selectedLocation.id,
          store.partnerId
        )
        return (
          <InteliblyRequest
            providerId={store.providerId}
            practiceId={store.practiceId !== '' ? store.practiceId : undefined}
            locationId={store.locationId}
            partnerId={store.partnerId}
          />
        )
      case 'schedule_connect':
        store.debug('RENDERING SCHEDULE CONNECT')
        Analytics.scheduleConnectOpened(
          store.selectedLocation.id,
          store.partnerId
        )
        return (
          <ScheduleConnectBooking
            locationId={store.locationId}
            partnerId={store.partnerId}
          />
        )
      case 'manual':
        store.debug('RENDERING MANUAL BOOKING')
        Analytics.manualBookingOpened(
          store.selectedLocation.id,
          store.partnerId
        )
        return (
          <ManualBooking
            locationId={store.locationId}
            partnerId={store.partnerId}
            providerId={store.providerId}
          />
        )
      default:
        store.debug('RENDERING NOOP')
        return <div data-testid="noop"></div>
    }
  }
})

export default BookingPath
